import React, { useRef } from "react";
import $ from 'jquery';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";

const CustomPreLoader2 = (props) => {
    const latestPropsRef = useRef(props);

    React.useEffect(() => {
        if(window.StatusBar && window.device && window.device.platform == "iOS") window.StatusBar.overlaysWebView(true);

        return () => {
            if(window.StatusBar && window.device && window.device.platform == "iOS") window.StatusBar.overlaysWebView(false);
        }
    },[])

    React.useEffect(() => {
        latestPropsRef.current = props;
    });

    React.useEffect(() => {
        const timer = setTimeout(() => {
            console.log("Sending analytics: loading took more than 7 seconds");
            const {
                isDeviceConfigResponse,
                isServerTimeResponse,
                isHotelPrefLanguageResponse,
            } = latestPropsRef.current;

            const apiStates = {
                isDeviceConfigResponse,
                isServerTimeResponse,
                isHotelPrefLanguageResponse,
            };

            const localStorageSnapshot = {};
            const excludePatterns = [
                /^deviceConfigCache/,
                /^layoutCssData/,
                /^Cached_Dynamic_CSS/,
            ];

            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                const isExcluded = excludePatterns.some((pattern) => pattern.test(key));
                if (!isExcluded) {
                    try {
                        localStorageSnapshot[key] = localStorage.getItem(key);
                    } catch (e) { }
                }
            }

            const debugPayload = {
                screen: 'CustomPreLoader2',
                timestamp: new Date().toISOString(),
                localStorage: localStorageSnapshot,
                userAgent: navigator.userAgent,
                apiStates
            };

            const label = getDefaultAnalyticsLabel({
                appVersion: props.installedAppVersion
                    ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
                    : ""
            });

            props.sendAnalytics(
                props.guestDetail,
                "APP_LOAD_OVER_X_SECS",
                "loading took more than 7 seconds",
                {
                    ...label,
                    pageName: "CustomPreLoader2",
                    timestamp: new Date().toISOString(),
                    ...apiStates
                },
                0,
                props.guestIsLoggedIn,
            );

            if (window && window.FirebasePlugin && typeof window.FirebasePlugin.logError === 'function') {
                try {
                    const stringifiedPayload = JSON.stringify(debugPayload);
                    const errorMessage = `APP_LOAD_OVER_X_SECS: Preloading screen took more than 7 seconds\nDetails: ${stringifiedPayload}`;

                    window.FirebasePlugin.logError(errorMessage);
                    window.FirebasePlugin.logEvent("APP_LOAD_OVER_X_SECS", debugPayload);
                } catch (e) {
                    console.warn("Failed to log error to Firebase", e);
                }
            }

            console.log("debugPayload", debugPayload); 
            
        }, 10000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <section class="overlay">
            <div class="overlay-window-container preloader" style={{background: `url("custom_preloader.jpg") center center no-repeat`, backgroundSize: "cover"}} >
                <div class="preloader-logo">
                    <img src="custom_hotel_logo.svg" />
                </div>
                <div class="loader-ring">
                    <img src="layout_2/assests/loader.png" />
                </div>

                {props.showNotificationBox && <div class="preloader-text">
					<p class="heading">Please wait...</p>
					<p>Loading is taking more time than usual, please wait a moment.</p>
				</div>}

                {process.env.REACT_APP_SHOW_APP_VERSION_ON_PRE_LOADIND_SCREEN2 === "true" && <div class="app-version">
					<p class="text">{`V${props.installedAppVersion}(${props.installedAppBuildNo})`}</p>
                </div>}

            </div>
        </section>
    )
}

const mapStateToProps = state => {
    return {
        showNotificationBox: state.store2.showNotificationBox,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        guestDetail: state.store.home.guestDetails,
    }
}

export default connect(mapStateToProps,{sendAnalytics})(withTranslation('translations')(CustomPreLoader2));